export enum SortField {
  Id = 'id',
  Name = 'name',
  Created = 'created',
  Updated = 'updated',
  Relevance = 'relevance',
  Category = 'category',
  Size = 'size',
  Mimetype = 'mimetype',
  Popularity = 'popularity',
  Property = 'property',
  DeploymentDate = 'deploymentdate'
}
